import React from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Info from '@jda/lui-common-icon-library/ui/Info';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      opacity: 0.4
    },
    pagination: {
      top: 'auto',
      right: '1%',
      opacity: 0.4,
      position: 'absolute',
      zIndex: 999
    }
  })
);

interface pageInfoProps {
  pageLevelInfo?: pageLevelInfo;
  pagination?: boolean;
}

interface pageLevelInfo {
  title?: string;
  content?: string;
}

const PageInfo: React.FunctionComponent<any> = (props: pageInfoProps) => {
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState<any>('paper');
  const { pageLevelInfo, pagination } = props;
  const classes = useStyles();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef<HTMLButtonElement>(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <>
      {pageLevelInfo?.title && pageLevelInfo?.content && (
        <>
          <Button
            id="demo-positioned-button"
            aria-controls="demo-positioned-menu"
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClickOpen}
            className={pagination ? classes.root : classes.pagination}
          >
            <Info fontSize="small" />
          </Button>
          <Dialog
            open={open}
            onClose={handleClose}
            scroll={scroll}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
          >
            <DialogTitle id="scroll-dialog-title">
              <div dangerouslySetInnerHTML={{ __html: pageLevelInfo.title }} />
            </DialogTitle>
            <DialogContent dividers={scroll === 'paper'}>
              <DialogContentText id="scroll-dialog-description" ref={descriptionElementRef} tabIndex={-1}>
                <div dangerouslySetInnerHTML={{ __html: pageLevelInfo.content }} />
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Ok</Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </>
  );
};

export default PageInfo;
